<template>
  <div>
    <Banner :imageList="bannerImages" :showSlider="showTopSlider" type="home" :hideMoble="false" />
    <search-tab />
    <ContentLoading type="banner" v-if="!loaded"/>
    <h1 class="flying-advertisement text-center pt-5" v-if="!hideMarketingDeals">{{ $t("home.flying-advertisement")}}</h1>
    <TopBanner :topBanner="topBanner" v-if="showTopBanner && topBanner && topBanner.length > 0 && !hideMarketingDeals"/>

    <div v-if="!dealData && !hideMarketingDeals" class="loading-message">{{ $t('home.deal-loading-message') }}</div>
    <Lesiurpackages :promotionData="dealData" v-if="dealData && !!dealData.length && !hideMarketingDeals && !hideSlider" />
    <ContentLoading v-if="!dealData && !hideMarketingDeals" type="deal" />
    <Lesiurtabs
      :dealType="dealType"
      :dealData="dealData"
      :banner="middleBanner"
      :bannerHref="middleBannerHref"
      :showBanner="showMiddleBanner"
      v-if="!!dealData && !!middleBanner && !hideMarketingDeals"
    />
    <Footer page="home" v-if="!hideFooter"/>

  </div>
</template>

<script>
import TemplateHome from './TemplateHome';

export default {
  name: 'Home1',
  mixins: [TemplateHome],
  components: {
    Banner: () => import('@/components/content/Banner'),
    SearchTab: () => import('@/components/search/searchTabs/SearchTabsTheme1'),
    Lesiurpackages: () => import('@/components/home/Lesiurpackages'),
    Lesiurtabs: () => import('@/components/home/lesiurtabs/LesiurtabsTheme1'),
    Footer: () => import('@/components/content/footer/FooterTheme1'),
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    TopBanner: () => import('@/components/home/topBanner/TopBannerTheme1'),
  },
};
</script>

<style>
  @media (min-width: 1520px){
    .container {
      max-width: 1574px;
    }
  }
  @media(max-width: 1399px) {
    .container {
      max-width: 1320px;
    }
  }
</style>

<style scoped>
  .flying-advertisement {
    font-family: "ploni";
    font-weight: 'bold';
    text-transform: 'capitalize';
    font-size: 48px;
    color: #000000;
    margin-bottom: 24px;
    margin-top: 70px;
  }

  @media (max-width: 767px) {
    .flying-advertisement {
      font-size: 2rem;
      padding: 5px;
      margin-bottom: 0px;
      padding-top: 30px !important;
      margin-top: 0px;
    }
  }
</style>
